import React, { lazy, Suspense } from "react";
import Login from "@/pages/Login"; //登录
import PageNotFound from "@/pages/PageNotFound";
import { createFromIconfontCN, ApartmentOutlined, ProjectOutlined, TeamOutlined, UserOutlined, FolderOutlined, HomeOutlined, SettingOutlined, CommentOutlined } from "@ant-design/icons";

const IconFont = createFromIconfontCN({
  scriptUrl: [process.env.REACT_APP_ICON],
});

const PNode = lazy(() => import("@/pages/admin"));

const Home = lazy(() => import("@/pages/admin/newHome"));
const DataSet = lazy(() => import("@/pages/admin/DataSet"));
const DatasetDetail = lazy(() => import("@/pages/admin/DataSet/detail"));
const Supplier = lazy(() => import("@/pages/admin/supplier"));
const SupplierList = lazy(() => import("@/pages/admin/supplier/list"));
const PMList = lazy(() => import("@/pages/admin/PMManage/PMList"));
const InspectorList = lazy(() => import("@/pages/admin/inspector/list")); // 验收员管理
const InspectorCreate = lazy(() => import("@/pages/admin/inspector/create")); // 验收员管理
const ProjectManagement = lazy(() => import("@/pages/admin/projectManagement")); // 项目管理
const SettleManagement = lazy(() => import("@/pages/admin/settleManagement")); // 结算管理
const SettleDetail = lazy(() => import("@/pages/admin/settleManagement/detail")); // 结算管理详情
const InquirySheet = lazy(() => import("@/pages/admin/inquirySheet")); // 询价单管理
const InquirySheetDetail = lazy(() =>
  import("@/pages/admin/inquirySheet/detail")
); // 询价单管理详情
const InquiryApproveSheetDetail = lazy(() =>
  import("@/pages/admin/inquirySheet/approveDetail")
); // 询价单管理详情
const TerminalMan = lazy(() => import("@/pages/admin/terminalMan")); // 用户管理
const FeedBack = lazy(() => import("@/pages/admin/feedBack")); // 问题反馈
const PersonalCenter = lazy(() => import("@/pages/admin/personalCenter")); // 个人中心
const TeamRecruitment = lazy(() => import("@/pages/admin/teamRecruitment")); // 团队招募列表

export const mainRoutes = [
  {
    path: "/login",
    // path: token == null ? "/login" : "/admin/home",
    component: Login,
    title: "Login_62c726fe-de03-2864-be71-cbf35ce30098",
    key: "login",
  },
  {
    path: "/404",
    component: PageNotFound,
    title: "404",
    isExt: false,
  },
];

export const adminRoutes = [
  {
    title: "NewHomepage_90f32925-9e3c-22f6-8f36-962def8afb31",
    icon: <HomeOutlined />,
    path: "/admin/home",
    component: Home, //前端组件
    showInMenu: true,
    key: "home",
    index: 1,
  },
  {
    title: "Details_b2095900-b4a5-22dc-bc7c-07705c019c4c",
    path: "/admin/dataset/detail/:packetId",
    component: DatasetDetail,
    showInMenu: false,
    key: "dataset",
    index: 111,
  },
  {
    title: "Dataset_Management",
    icon: <ProjectOutlined />,
    path: "/admin/dataset",
    component: DataSet,
    showInMenu: true,
    key: "dataset",
    index: 11,
  },
  {
    title: "Inquiry_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/inquiryManage/detail",
    component: InquirySheetDetail, //前端组件
    key: "quotationManage",
    index: 6,
  },
  {
    title: "Inquiry_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/inquiryManage/approveDetail",
    component: InquiryApproveSheetDetail, //前端组件
    key: "quotationManage",
    index: 7,
  },
  {
    title: "Settle_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/settleManagement/detail",
    component: SettleDetail, //前端组件
    key: "settlementManage",
    index: 10,
  },
  {
    title: "supplier_management_6aa66577-824c-21e1-b18a-f10478dc9dc9",
    icon: <IconFont type="icon-gongyingshangguanli" />,
    path: "/admin/teamManage",
    component: SupplierList, //前端组件
    showInMenu: true,
    key: "teamManage",
    index: 3,
  },
  {
    title: "supplier_management_6aa66577-824c-21e1-b18a-f10478dc9dc9",
    icon: <TeamOutlined />,
    component: PNode, //前端组件
    path: '/admin/team',
    children: [
      {
        title: "Supplier_Homepage_192c9db2-076f-26ee-8099-2e70ecf51b36",
        path: "/admin/team/teamHome",
        component: Supplier, //前端组件
        showInMenu: true,
        key: "teamHome",
        index: 4,
      },
      {
        title: "315d3af8-7da3-2250-9c26-34cdaea5d7b6",
        path: "/admin/team/teamRecruitment",
        component: TeamRecruitment, // 团队招募
        exact: true, //路由是否全匹配
        showInMenu: true,
        key: "teamRecruitment",
      }],
  },
  {
    title: "Project_Management_fd8b706f-45dc-2c4a-8b0e-0577a75de6fa",
    icon: <FolderOutlined />,
    component: PNode, //前端组件
    path: '/admin/project',
    children: [
      {
        title: "Project_Management_fd8b706f-45dc-2c4a-8b0e-0577a75de6fa-1",
        path: "/admin/project/projectManage",
        component: ProjectManagement, //前端组件
        showInMenu: true,
        key: "projectManage",
        index: 8,
      },
      {
        title: "Inquiry_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
        path: "/admin/project/inquiryManage",
        component: InquirySheet, //前端组件
        exact: true, //路由是否全匹配
        showInMenu: true,
        key: "quotationManage",
        index: 5,
      },
      {
        title: "Settle_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
        path: "/admin/project/settleManagement",
        component: SettleManagement, //前端组件
        exact: true, //路由是否全匹配
        showInMenu: true,
        key: "settlementManage",//settleManage
        index: 9,
      },
    ]
  },
  {
    title: "Worker_Management_d308ca5d-8799-289e-8a59-dc6c3292e7ea",
    icon: <UserOutlined />,
    path: "/admin/userManage",
    component: TerminalMan, //前端组件
    showInMenu: true,
    key: "userManage",
    index: 11,
  },
  {
    title: "PM_Management_31b5f5cd-78b4-2bf0-82a8-1f992a890871",
    icon: <ApartmentOutlined />,
    path: "/admin/PMManage",
    component: PMList, // 内部管理
    showInMenu: true,
    key: "PMManage",
    index: 12,
  },
  {
    title: "Inspector_Management_b0322bf7-3c40-24a9-88f5-fec65a44901c",
    icon: <TeamOutlined />,
    path: "/admin/inspector/list",
    component: InspectorList, //前端组件
    showInMenu: true,
    key: "companyManage1",
    index: 13,
  },
  {
    title: "Inspector_Management_b0322bf7-3c40-24a9-88f5-fec65a44901c",
    icon: <TeamOutlined />,
    path: "/admin/inspector/create",
    component: InspectorCreate, //前端组件
    showInMenu: false,
    key: "companyManage1",
    index: 14,
  },
  {
    title: "Account_Center_9253f02a-772f-2d9c-a902-6afed7c36c9e",
    icon: <SettingOutlined />,
    path: "/admin/personalCenter", ///:id
    component: PersonalCenter, //前端组件
    showInMenu: true,
    key: "personalCenter",
    index: 15,
  },
  {
    title: "Report_Issue_b531f551-9d61-2f83-9863-edd3d66a96cc",
    icon: <CommentOutlined />,
    path: "/admin/feedback", ///:id
    component: FeedBack, //前端组件
    showInMenu: true,
    key: "feedback",
    index: 16,
  },
];